import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Package } from "lucide-react";

/* Frictionless first-time-visitor gateway to the product catalogue.
 * Renders immediately below the hero, before category browsing, so a new
 * visitor can reach every product in a single tap. */
export const ShopGateway = () => (
    <section
        className="relative py-16 md:py-20 border-t border-white/5"
        data-testid="shop-gateway"
    >
        {/* Subtle carbon-fibre substrate + cyan glow anchor */}
        <div
            aria-hidden="true"
            className="absolute inset-0 pointer-events-none opacity-70"
            style={{
                background:
                    "radial-gradient(100% 60% at 50% 10%, rgba(0,229,255,0.10) 0%, transparent 55%)," +
                    "repeating-linear-gradient(45deg, rgba(255,255,255,0.02) 0 2px, rgba(0,0,0,0.35) 2px 4px)",
                backgroundBlendMode: "normal, overlay",
            }}
        />

        <div className="container-x relative">
            <div className="max-w-3xl mx-auto text-center">
                <div className="inline-flex items-center gap-2 mb-5">
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--cyan)] shadow-[0_0_8px_rgba(0,229,255,0.8)]" />
                    <span className="text-[10px] font-mono uppercase tracking-[0.32em] text-[var(--cyan-hi)]">
                        // Catalogue
                    </span>
                    <span className="inline-block w-1.5 h-1.5 rounded-full bg-[var(--cyan)] shadow-[0_0_8px_rgba(0,229,255,0.8)]" />
                </div>

                <h2
                    className="font-display uppercase font-black leading-[0.9] tracking-tight text-metal-gold mb-4"
                    style={{
                        fontFamily: "'Chakra Petch', 'Rajdhani', sans-serif",
                        fontSize: "clamp(40px, 10vw, 72px)",
                        letterSpacing: "-0.01em",
                        textShadow: "0 1px 0 rgba(240,244,248,0.85), 0 2px 0 rgba(15,20,25,0.7), 0 6px 14px rgba(0,0,0,0.75), 0 0 22px rgba(0,229,255,0.28)",
                    }}
                    data-testid="shop-gateway-heading"
                >
                    Shop Products
                </h2>

                <p className="text-[var(--text-secondary)] text-base md:text-lg leading-relaxed mb-9 max-w-xl mx-auto">
                    Browse the complete Carbon Labs research catalogue —
                    every peptide lot-traceable, cold-chained and dispatched
                    from our Sydney facility.
                </p>

                <Link
                    to="/shop"
                    className="inline-flex items-center gap-3 pl-7 pr-6 py-4 rounded-full border border-[var(--cyan)] bg-[rgba(0,229,255,0.10)] text-[var(--cyan-hi)] font-mono uppercase text-xs tracking-[0.24em] font-semibold hover:bg-[rgba(0,229,255,0.20)] hover:shadow-[0_0_22px_rgba(0,229,255,0.5)] transition-all"
                    data-testid="shop-gateway-cta"
                >
                    <Package size={15} strokeWidth={2.4} />
                    View All Products
                    <ArrowRight size={15} strokeWidth={2.4} />
                </Link>
            </div>
        </div>
    </section>
);
